import React, { useEffect, useState, useRef } from 'react';
interface StatCounterProps {
  end: number;
  duration?: number;
  suffix?: string;
  label: string;
}
export function StatCounter({
  end,
  duration = 2000,
  suffix = '',
  label
}: StatCounterProps) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const hasAnimated = useRef(false);
  useEffect(() => {
    const element = ref.current;
    if (!element || hasAnimated.current) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          const startTime = Date.now();
          const animate = () => {
            const now = Date.now();
            const progress = Math.min((now - startTime) / duration, 1);
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            setCount(Math.floor(easeOutQuart * end));
            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          };
          animate();
        }
      });
    }, {
      threshold: 0.5
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [end, duration]);
  return <div ref={ref} className="text-center" data-id="element-148">
      <div className="text-5xl md:text-6xl font-bold text-gray-900 mb-2" data-id="element-149">
        {count.toLocaleString()}
        {suffix}
      </div>
      <div className="text-sm text-gray-600 uppercase tracking-wider" data-id="element-150">
        {label}
      </div>
    </div>;
}